import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import {
  firebaseMutations,
  firebaseAction
} from 'vuexfire'
import u from '@/util'

const test = process.env.NODE_ENV.startsWith('test') ||
  (process.env.NODE_ENV2 && process.env.NODE_ENV2.startsWith('test'))

// console.log(process.env.NODE_ENV, process.env.NODE_ENV2)

const firebaseConfig = test ?
  // Testing
  {
    apiKey: 'AIzaSyAMnViG064IYTm_llThcTnlome6qD3LQBc',
    authDomain: 'carecellappunittest.firebaseapp.com',
    databaseURL: 'https://carecellappunittest.firebaseio.com',
    projectId: 'carecellappunittest',
    storageBucket: 'carecellappunittest.appspot.com',
    messagingSenderId: '990946197689'
  } :
  process.env.NODE_ENV.startsWith('dev') ?
  // Development

  {
    apiKey: 'AIzaSyDBdsP2PS_i7k7R8sxOzWXhRywSvaLzyho',
    authDomain: 'carecellapptest.firebaseapp.com',
    databaseURL: 'https://carecellapptest.firebaseio.com',
    projectId: 'carecellapptest',
    storageBucket: 'carecellapptest.appspot.com',
    messagingSenderId: '912627017107'
  } :
  // Production

  {
    apiKey: 'AIzaSyBCRfjBe4H_NHUL4WsRmX_5DyV1FfN-XUg',
    authDomain: 'carecellapp.firebaseapp.com',
    databaseURL: 'https://carecellapp.firebaseio.com',
    projectId: 'carecellapp',
    storageBucket: 'carecellapp.appspot.com',
    messagingSenderId: '246445345745'
  }

// Add ?1=1 to avoid "Invalid query segment warning"
firebaseConfig.databaseURL += '?1=1'
firebase.initializeApp(firebaseConfig)
export const db = firebase.database()
export const auth = firebase.auth()

export const refOnce = ref => ref.once('value').then(snapshot => snapshot.val())

export async function clear() {
  if (test) {
    return assignments.ref.set(null)
  }
}

const bindMutations = firebaseMutations

function bind(property, dbRef) {
  return firebaseAction(({
    bindFirebaseRef
  }, payload) => {
    bindFirebaseRef(property, dbRef(payload))
  })
}

const assignments = {
  ref: db.ref('assignments'),

  bindAssignment(property) {
    return bind(property, cell => this.ref.orderByChild('cell').equalTo(cell))
  },

  unbindAssignment(property) {
    return firebaseAction(({
      unbindFirebaseRef
    }) => unbindFirebaseRef(property))
  },

  mutations: firebaseMutations,

  async findAll() {
    return refOnce(this.ref).then(u.objectToArray)
  },

  async findByPerson(person) {
    return refOnce(this.ref.orderByChild('person').equalTo(person)).then(u.objectToArray)
  },

  async findByCell(cell) {
    return refOnce(this.ref.orderByChild('cell').equalTo(cell)).then(u.objectToArray)
  },

  async findByPersonLast(person, cell) {
    return this.findByPerson(person).then(items => {
      for (let i = items.length; i-- > 0;) {
        const item = items[i]
        if ((item.role !== 'G' && item.role !== 'V') || item.start) {
          return item
        }
      }
    })
  },

  async findByCellDate(cell, date) {
    // Get all cell assignments
    return this.findByCell(cell).then(items => {
      const found = {}
      const filtered = []
      // Leave only the last assignment for each person, thus interate in reverse order
      for (let i = items.length; i-- > 0;) {
        const item = items[i]
        if (u.periodsOverlap(item.start, item.end, date, date)) {
          if (!found[item.person]) {
            found[item.person] = true
            if (item.role !== 'N') {
              filtered.push(item)
            }
          }
        }
      }
      return filtered.sort(u.comparator('person'))
    })
  },

  async save(item) {
    const {
      person,
      cell,
      role,
      start,
      end
    } = item
    const updates = {}

    // Validate not empty arguments
    const emptyArgs = ['person', 'cell', 'role', 'start'].filter(key => !item[key])
    if (emptyArgs.length) {
      return u.promiseError('Empty arguments', JSON.stringify(emptyArgs))
    }

    // Find assignment for the given person from the same group
    const items = (await this.findByPerson(person))
      .filter(it => it.cell === cell)
      .sort((a, b) => a.start < b.start ? -1 : a.start > b.start ? 1 : 0)

    // If the item already exists then update it
    const existing = items.find(it => it['.key'] === item['.key'])
    if (existing) {
      // TODO make sure new start and end do not overlap
      updates[`/assignments/${existing['.key']}/start`] = start
      if (end) {
        updates[`/assignments/${existing['.key']}/end`] = end
      }
    } else { // If the item does not exist yet, check it's integrity
      // If the item.start date overlaps
      let found = items.slice(0, -1).find(it => u.periodsOverlap(start, start, it.start, it.end))
      if (found) {
        return u.promiseError('Assignment periods overlap', found)
      } else if (items.length) {
        // TODO ensure no overlapping between last and item
        const last = items[items.length - 1]
        if (last.role === role) {
          return u.promiseError('Has that role already', last)
        } else if (last.start >= item.start) {
          // Remove the last item
          updates[`/assignments/${last['.key']}`] = null
        } else {
          updates[`/assignments/${last['.key']}/end`] = u.dateAdd(start, -1)
          const newKey = assignments.ref.push().key
          updates[`/assignments/${newKey}`] = {
            person,
            cell,
            role,
            start
          }
        }
      }
    }

    // // Iterate over the person assignments in the reverse order and find integrity violations
    // const items = await this.findByPerson(person)
    // let last = null
    // let createNew = true
    // for (let i = items.length; i-- > 0;) {
    //   last = items[i]
    //   const theSameKey = last['.key'] === item['.key']

    //   // If cell is the same
    //   if (last.cell === cell) {
    //     // If the role is the same
    //     if (last.role === role && !theSameKey && (!last.end || last.end >= item.start)) {
    //       return u.promiseError('Has that role already', last)
    //     }
    //     // If the date is the same
    //     console.log('equal keys', last['.key'] === item['.key'])
    //     console.log('equal start', last.start === start)
    //     if (last.start === start) {
    //       // Remove the previous assignment and keep walking
    //       updates[`/assignments/${last['.key']}`] = null
    //       last = null
    //       continue
    //     } else if (theSameKey) {
    //       // Update date
    //       updates[`/assignments/${last['.key']}/start`] = start
    //       if (end) {
    //         updates[`/assignments/${last['.key']}/end`] = end
    //       }
    //       createNew = false
    //     }
    //   } else {
    //     // Different cell
    //     const lastType = (await cells.findOne(last.cell)).type
    //     // console.log(last.cell, cell, lastType, type)
    //     if (last.role !== 'N' && last.role !== 'V' && last.role !== 'G' &&
    //       role !== 'G' && role !== 'V' && role !== 'N' && type === lastType &&
    //       u.periodsOverlap(last.start, last.end, start, end)) {
    //       const params = {
    //         ...last,
    //         from: start,
    //         to: (end || t('always'))
    //       }
    //       return u.promiseError('Assigned to another cell', params)
    //     } else {
    //       last = null
    //     }
    //   }
    // }

    // console.log(end, last, createNew)
    // if (last && createNew) {
    //   updates[`/assignments/${last['.key']}/end`] = u.dateAdd(start, -1)
    // } else {
    //   // No last assignment
    //   // Then it does not make sense to make it Nobody
    //   if (role === 'N') return
    // }

    // if (createNew) {
    //   const newKey = assignments.ref.push().key
    //   updates[`/assignments/${newKey}`] = {
    //     person,
    //     cell,
    //     role,
    //     start
    //   }
    // }

    console.log('save', updates)
    return db.ref().update(updates).then(() => item)
  },

  async changeName(oldPerson, newPerson, key, cell, dates) {
    const updates = {}
    dates.forEach(async date => {
      const path = `/meetings/${cell}/${date}/attendance`
      const attendance = (await refOnce(db.ref(path))) || []
      const index = attendance.indexOf(oldPerson)
      if (index !== -1) {
        attendance.splice(index, 1)
        attendance.push(newPerson)
        updates[path] = attendance
      }
    })
    updates[`/assignments/${key}/person`] = newPerson
    return db.ref().update(updates)
  },

  async end(item) {
    /* eslint no-debugger: "off" */
    return this.ref.child(item['.key']).child('end').set(item.end)
  },

  async remove(item) {
    return this.ref.child(item['.key']).remove()
      .then(() => this.findByPersonLast(item.person))
      .then(last => last && this.ref.child(last['.key']).child('end').remove())
  },

  async clear() {
    if (test) {
      return assignments.ref.set(null)
    }
  }
}

const assignments2 = {
  ref: db.ref('assignments2'),

  bindAssignment(property) {
    return bind(property, cell => this.ref.orderByChild('cell').equalTo(cell))
  },

  unbindAssignment(property) {
    return firebaseAction(({
      unbindFirebaseRef
    }) => unbindFirebaseRef(property))
  },

  async findByCell(cell) {
    return refOnce(this.ref.orderByChild('cell').equalTo(cell)).then(u.objectToArray)
  },

  async findAll() {
    return refOnce(this.ref).then(u.objectToArray)
  },

  async add(item) {
    const {
      cell,
      person,
      role
    } = item
    const newKey = this.ref.push().key

    return this.ref.child(newKey).set({
      cell,
      person,
      role
    }).then(() => item)
  },

  async remove(item) {
    return this.ref.child(item['.key']).remove()
  }
}

const cells = {
  ref: db.ref('cells'),

  bindCells(property) {
    return bind(property, () => this.ref)
  },

  unbindCells(property) {
    return firebaseAction(({
      unbindFirebaseRef
    }) => unbindFirebaseRef(property))
  },

  findOne(cell) {
    return refOnce(this.ref.child(cell))
  },
  findByType(type) {
    return type ? refOnce(this.ref.orderByChild('type').equalTo(type)).then(u.objectToArray) :
      cells.findAll()
  },
  findAll() {
    return refOnce(this.ref)
  },
  async save(key, values) {
    return this.ref.child(key).update(values)
  }
}

const meetings = {
  ref: db.ref('meetings'),

  async findDates(cell) {
    return refOnce(this.ref.child(cell).child('dates'))
  },

  async findByCellDate(cell, date) {
    return refOnce(this.ref.child(cell).child(date))
  },

  async findByCell(cell) {
    return refOnce(this.ref.child(cell))
  },

  /** To remove save with meeting = null */
  async save(cell, dates, date, dateToRemove, meeting, stat) {
    // const key = stat ? db.ref('stats').push().key : await stats.findKey(cell, date)
    const updates = {}
    updates[`/meetings/${cell}/dates`] = dates
    updates[`/meetings/${cell}/${date}`] = meeting
    if (dateToRemove) {
      updates[`/meetings/${cell}/${dateToRemove}`] = null
    }
    // updates[`/stats/${key}`] = stat || null
    return db.ref().update(updates)
  },

  async attendanceByCellDates(cell, from, to) {
    // const dates = refOnce(this.ref.child(cell).child('dates'))
    // return Promise.all(dates)
    //   .filter(d => u.periodOverlap(a.start, a.end, from, to))
    //   .map(d => refOnce(db.ref.child(cell).child(d).attendance))
  }
}

const meetings2 = {
  ref: db.ref('meetings2'),

  async findDates(cell) {
    return refOnce(this.ref.child(cell).child('dates'))
  },

  async findByCellDate(cell, date) {
    return refOnce(this.ref.child(cell).child(date))
  },

  async findByCell(cell) {
    return refOnce(this.ref.child(cell))
  },

  /** To remove save with meeting = null */
  async save(cell, dates, date, dateToRemove, meeting, stat) {
    // const key = stat ? db.ref('stats').push().key : await stats.findKey(cell, date)
    const updates = {}
    updates[`/meetings2/${cell}/dates`] = dates
    updates[`/meetings2/${cell}/${date}`] = meeting
    if (dateToRemove) {
      updates[`/meetings2/${cell}/${dateToRemove}`] = null
    }
    // updates[`/stats/${key}`] = stat || null
    return db.ref().update(updates)
  }
}
// tsttnvhhlfmvwagn
const mailer = {
  create(email) {
    return db.ref('/mailer2').push(email)
  }
}

const stats = {
  ref: db.ref('/stats'),
  async findKey(cell, date) {
    const items = await refOnce(this.ref.orderByChild('cell').equalTo(cell))
    if (!items) return null
    return Object.keys(items).find(k => items[k].date === date)
  },
  async findByDates(from, to) {
    const items = await refOnce(this.ref.orderByChild('cell')).then(u.objectToArray)
    return items.filter(_ => from <= _.date && _.date <= to)
  },
  create(record) {
    return this.ref.push(record)
  }
}

const users = {
  getEmailsByRole(role) {
    return db.ref('/users').orderByChild('role').equalTo(role).once('value').then(snapshot => {
      return snapshot.val()
    })
  }
}

const config = {
  ref: db.ref('/config'),
  findOne() {
    return refOnce(this.ref)
  },
  save(record) {
    return this.ref.set(record)
  },
  onVersion(listener) {
    this.ref.child('version').on('value', snapshot => {
      listener(snapshot.val())
    })
  }
  // getCellSymbol () {
  //   return this.ref.transaction(function transactionUpdate (config) {
  //     if (config) {
  //       config.cellSymbolCounter = (config.cellSymbolCounter || 0) + 1
  //     }
  //     return config
  //   }, false).then(result => {
  //     const counter = '' + result.snapshot.val().cellSymbolCounter
  //     return (counter.length === 1 ? 'AA' : counter.length === 2 ? 'A' : '') + counter
  //   })
  // },
}

window.dal = {
  bindMutations,
  config,
  cells,
  assignments,
  assignments2,
  mailer,
  meetings,
  meetings2,
  stats,
  users,
  db,
  auth,
  firebase,
  clear,
  refOnce
}
export default window.dal
